import { render, staticRenderFns } from "./RecordSettingPanel.vue?vue&type=template&id=6c34544e&scoped=true"
import script from "./RecordSettingPanel.vue?vue&type=script&lang=ts"
export * from "./RecordSettingPanel.vue?vue&type=script&lang=ts"
import style0 from "./RecordSettingPanel.vue?vue&type=style&index=0&id=6c34544e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34544e",
  null
  
)

export default component.exports